// @flow
import { setActiveLanguage } from 'react-localize-redux';
import { fetchMe } from './user.actions';

const GET_ENVIRONMENT = '/api/env';
const GUESS_USER = '/api/u?u=:u';
const DELETE_USER = '/api/u?u=:u';
const GUESS_USER_SITE = '/api/u/site?u=:u';
const SWITCH_AGENCY = '/api/u/switchAgency';
const SWITCH_AGENCY_PLANS = '/api/u/switchAgencyPlans';
const UNSUBSCRIBE_SEO_EMAIL =
  '/api/projects/:idx/unsubscribeSeoPerformanceEmail?uid=:uid&signed=:signed';
export const ENV_UPDATED = 'env/UPDATED';
export const USERLIST_UPDATED = 'admin/USERLIST_UPDATED';

export const getEnv = () => {
  return (dispatch: Function) => {
    fetch(GET_ENVIRONMENT, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
      .then((response) => {
        return response.json().then((data) => {
          return { data, status: response.status };
        });
      })
      .then(({ data, status }) => {
        dispatch({ type: ENV_UPDATED, data });
      });
  };
};

export default {
  getEnv
};



// WEBPACK FOOTER //
// ./src/actions/app.actions.js